import styled from '@emotion/styled';
import { Tab as _Tab, Tabs } from '@material-ui/core';
import Audiotrack from '@material-ui/icons/Audiotrack';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import { ChangeEvent, createElement, ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { MaterialTypeDefinition, MaterialTypeOption, materialTypeOrder } from '../../../../entity/SearchAsset';
import mq from '../../../styleUtility/mediaquery';

type Props = {
  materialType: MaterialTypeDefinition;
  materialTypeOption: MaterialTypeOption;
  resetSearch: () => void;
  scrollToTop: () => void;
  handleChange: (newMaterialTypeIndex: number) => void;
};

const getLabelIcon = (type: 'video' | 'image' | 'audio'): string | ReactElement => {
  if (type === 'video') {
    return <VideoLibraryIcon />;
  } else if (type === 'image') {
    return <PhotoLibraryIcon />;
  } else if (type === 'audio') {
    return <Audiotrack />;
  }
  return '';
};

export const MaterialTypeTab = ({
  materialType,
  materialTypeOption,
  resetSearch,
  scrollToTop,
  handleChange,
}: Props) => {
  const handleClickTab = (_: ChangeEvent<unknown>, nextIndex: number) => {
    scrollToTop();
    resetSearch();
    handleChange(nextIndex);
  };

  return (
    <Tabs value={materialType.index} indicatorColor="primary" textColor="primary" onChange={handleClickTab}>
      {materialTypeOrder.map((type) => {
        if (materialTypeOption[type].enableRecommend || materialTypeOption[type].enableSearch) {
          return (
            <Tab
              key={type}
              label={<FormattedMessage id={`search_file_uploader.material_type.${type}`} />}
              icon={getLabelIcon(type)}
            />
          );
        } else {
          return <DisabledMaterialTab key={type} />;
        }
      })}
    </Tabs>
  );
};

const Tab = styled(_Tab)`
  .MuiTab-wrapper {
    align-items: normal;
    flex-direction: row;
  }

  .MuiSvgIcon-root {
    margin-right: 4px;
  }
  &.MuiTab-root {
    ${mq('sp')} {
      width: 33%;
      min-width: 33%;
      min-height: 35px;
      padding: 9px;
    }
  }
`;

const DisabledMaterialTab = styled(_Tab)`
  display: none;
`;
